export enum SortBy {
  TOP100 = 'top100',
  REGISTRATION_ASC = 'registration_asc',
  REGISTRATION_DESC = 'registration_desc',
}

export enum BalanceType {
  PANDA = 'panda',
  COOKIE = 'cookie',
  TON = 'ton',
  XP = 'xp',
}
